import View from './View';
import Edit from './Edit';

const installSupersetBlock = (config) => {

  delete config.blocks.blocksConfig.supersetBlock;

  config.blocks.blocksConfig.supersetBlock = {
    id: 'supersetBlock',
    title: 'Dashboard Superset',
    icon: 'bar chart',
    group: 'common',
    view: View,
    edit: Edit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    // ESTA LINHA HABILITA OS BOTÕES DE ALINHAMENTO NO TOPO DA SIDEBAR
    enableAlign: true,
    // ESTA CONFIGURAÇÃO ADICIONA O ÍCONE DE LARGURA TOTAL ESPECIFICAMENTE
    allowed_align: ['left', 'center', 'right', 'full'],
    //stylesSchema: {
    //  fieldsets: [
    //    {
    //      id: 'default',
    //      title: 'Estilo',
    //      fields: ['align'],
    //    },
    //  ],
    //  properties: {
    //    align: {
    //      title: 'Alinhamento',
    //      type: 'string',
    //      widget: 'align', // Força o uso do widget de ícones de alinhamento
    //    },
    //  },
    //  required: [],
    //},
  };

  return config;
};

export default installSupersetBlock;
